import React from 'react';
import { DashboardLayout } from './DashboardLayout';

/** Sidebar + demo banner shell for any authenticated page (including company setup). */
export const AuthenticatedLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <DashboardLayout>{children}</DashboardLayout>
);
